/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Goals_Card_EmptyInputs */

const en_us2_exercise_personal_goals_card_empty = /** @type {(inputs: Exercise_Personal_Goals_Card_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set a goal from an exercise's sheet. The weight you want to reach and your best so far show up here.`)
};

const pt_br2_exercise_personal_goals_card_empty = /** @type {(inputs: Exercise_Personal_Goals_Card_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defina uma meta na ficha de um exercício. O peso que você quer alcançar e o seu melhor até agora aparecem aqui.`)
};

const es_419_exercise_personal_goals_card_empty = /** @type {(inputs: Exercise_Personal_Goals_Card_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define una meta desde la ficha de un ejercicio. El peso que quieres alcanzar y tu mejor marca hasta ahora aparecen aquí.`)
};

const pt_pt2_exercise_personal_goals_card_empty = /** @type {(inputs: Exercise_Personal_Goals_Card_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define um objetivo na ficha de um exercício. O peso que queres alcançar e o teu melhor até agora aparecem aqui.`)
};

const fr_fr2_exercise_personal_goals_card_empty = /** @type {(inputs: Exercise_Personal_Goals_Card_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fixe un objectif depuis la fiche d'un exercice. La charge à atteindre et ton meilleur actuel s'affichent ici.`)
};

const de_de2_exercise_personal_goals_card_empty = /** @type {(inputs: Exercise_Personal_Goals_Card_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leg ein Ziel in der Übersicht einer Übung fest. Dein Zielgewicht und dein bisheriger Bestwert erscheinen dann hier.`)
};

const it_it2_exercise_personal_goals_card_empty = /** @type {(inputs: Exercise_Personal_Goals_Card_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imposta un obiettivo dalla scheda di un esercizio. Il peso che vuoi raggiungere e il tuo migliore finora compaiono qui.`)
};

/**
* | output |
* | --- |
* | "Set a goal from an exercise's sheet. The weight you want to reach and your best so far show up here." |
*
* @param {Exercise_Personal_Goals_Card_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_goals_card_empty = /** @type {((inputs?: Exercise_Personal_Goals_Card_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Goals_Card_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_goals_card_empty(inputs)
	if (locale === "es-419") return es_419_exercise_personal_goals_card_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_goals_card_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_goals_card_empty(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_goals_card_empty(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_goals_card_empty(inputs)
	return en_us2_exercise_personal_goals_card_empty(inputs)
});
export { exercise_personal_goals_card_empty as "exercise-personal.goals_card_empty" }